const Pulse01Icon = /*#__PURE__*/ [
  ["path", { d: "M2 12H6L7.5 8L9.5 15L13 6L15.5 18L18 12H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Pulse01Icon as default };
//# sourceMappingURL=Pulse01Icon.js.map
